module.exports = __webpack_public_path__ + "img/logo.e8ce1b5.png";